import { render, staticRenderFns } from "./prescriptionDetail.vue?vue&type=template&id=4a912688"
import script from "./prescriptionDetail.vue?vue&type=script&lang=js"
export * from "./prescriptionDetail.vue?vue&type=script&lang=js"
import style0 from "./prescriptionDetail.vue?vue&type=style&index=0&id=4a912688&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports